import { render, staticRenderFns } from "./t-bulk-status-badge.vue?vue&type=template&id=59b5764a&"
import script from "./t-bulk-status-badge.vue?vue&type=script&lang=js&"
export * from "./t-bulk-status-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports